<template>
  <div v-if="showFullScreenBtn" class="full-screen-btn-con">
    <el-tooltip effect="dark" :content="value ? '退出全屏' : '全屏'" placement="bottom">
      <i class="group-list-right "  @click="handleChange" :class="value ? 'el-icon-control-exieFullScreen':'el-icon-control-fullScreen'"></i>
    </el-tooltip>
    <!--<Tooltip :content="value ? '退出全屏' : '全屏'" placement="bottom">-->
      <!--<i class="group-list-right "  @click="handleChange" :class="value ? 'el-icon-control-fullScreen':'el-icon-control-exieFullScreen'"></i>-->
      <!--<Icon @click.native="handleChange" :type="value ? 'md-contract' : 'md-expand'" :size="23"></Icon>-->
    <!--</Tooltip>-->
  </div>
</template>

<script>
  export default {
    name: 'Fullscreen',
    computed: {
      showFullScreenBtn () {
        return window.navigator.userAgent.indexOf('MSIE') < 0
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleFullscreen (element) {
        let main = document.body
        if (this.value) {
          if(document.exitFullscreen){
            document.exitFullscreen();
          }
          else if(document.mozCancelFullScreen){
            document.mozCancelFullScreen();
          }
          else if(document.msExitFullscreen){
            document.msExiFullscreen();
          }
          else if(document.webkitCancelFullScreen){
            document.webkitCancelFullScreen();
          }
          // if (document.exitFullscreen) {
          //   document.exitFullscreen()
          // } else if (document.mozCancelFullScreen) {
          //   document.mozCancelFullScreen()
          // } else if (document.webkitCancelFullScreen) {
          //   document.webkitCancelFullScreen()
          // } else if (document.msExitFullscreen) {
          //   document.msExitFullscreen()
          // }
          this.value = !this.value
          window.close()
        } else {
          // if(element.requestFullscreen){
          //   element.requestFullscreen();
          // }
          // else if(element.mozRequestFullScreen){
          //   element.mozRequestFullScreen();
          // }
          // else if(element.msRequestFullscreen){
          //   element.msRequestFullscreen();
          // }
          // else if(element.webkitRequestFullscreen){
          //   element.webkitRequestFullScreen();
          // }
          if (main.requestFullscreen) {
            main.requestFullscreen()
          } else if (main.mozRequestFullScreen) {
            main.mozRequestFullScreen()
          } else if (main.webkitRequestFullScreen) {
            main.webkitRequestFullScreen()
          } else if (main.msRequestFullscreen) {
            main.msRequestFullscreen()
          }
          this.value = !this.value
         ;
        }
      },
      handleChange () {
        this.handleFullscreen()
      },

      /*跨浏览器返回正处于全屏的元素*/
     fullscreenElement(){
        var fullscreenEle = document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement;
        //注意：要在用户授权全屏后才能获取全屏的元素，否则 fullscreenEle为null
        console.log("全屏元素："+fullscreenEle);
        return fullscreenEle;
      },

    /*跨浏览器返回当前 document 是否进入了可以请求全屏模式的状态*/
     fullscreenEnable(){
        var isFullscreen = document.fullscreenEnabled ||
          window.fullScreen ||
          document.webkitIsFullScreen ||
          document.msFullscreenEnabled;
        //注意：要在用户授权全屏后才能准确获取当前的状态
        if(isFullscreen){
          console.log('全屏模式');
        }else{
          console.log('非全屏模式');
        }
      },
    },
    mounted () {
      // let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen

      /*各浏览器fullscreenchange 事件处理*/
      document.addEventListener('fullscreenchange', function(){
        //屏幕改变模式时，执行的代码
        //退出全屏执行的代码
        if(this.fullscreenElement()==""|| this.fullscreenElement()==null){
          this.value = false
          //退出全屏或者全屏状态下点击ESC键时执行
        }
      });
      document.addEventListener('webkitfullscreenchange', function(){
        //屏幕改变模式时，执行的代码
      });

      document.addEventListener('mozfullscreenchange', function(){
        //屏幕改变模式时，执行的代码
      });

      document.addEventListener('MSFullscreenChange', function(){
        //屏幕改变模式时，执行的代码
      });

      /*各浏览器fullscreenerror 事件处理*/
      document.addEventListener('fullscreenerror', function(){
        /*全屏失败代码*/
      });
      document.addEventListener('webkitfullscreenerror', function(){
        /*全屏失败代码*/
      });
      document.addEventListener('mozfullscreenerror', function(){
        /*全屏失败代码*/
      });
      document.addEventListener('MSFullscreenError', function() {
        /*全屏失败代码*/
      })
      // isFullscreen = !!isFullscreen

      // document.addEventListener('fullscreenchange', () => {
      //   this.$emit('input', !this.value)
      //   this.$emit('on-change', !this.value)
      // })
      // document.addEventListener('mozfullscreenchange', () => {
      //   this.$emit('input', !this.value)
      //   this.$emit('on-change', !this.value)
      // })
      // document.addEventListener('webkitfullscreenchange', () => {
      //   this.$emit('input', !this.value)
      //   this.$emit('on-change', !this.value)
      // })
      // document.addEventListener('msfullscreenchange', () => {
      //   this.$emit('input', !this.value)
      //   this.$emit('on-change', !this.value)
      // })
      // this.$emit('input', isFullscreen)
    }
  }
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
  .full-screen-btn-con .ivu-tooltip-rel{
    height: 64px;
    line-height: 56px;
    i{
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Screenfull/index.vue